import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-theme-switcher',
  standalone: true,
  imports: [MatIconModule, CommonModule],
  templateUrl: './theme-switcher.component.html',
  styleUrl: './theme-switcher.component.scss'
})
export class ThemeSwitcherComponent {
  public isLightTheme = true;


  constructor(){
    this.isLightTheme =localStorage.getItem('theme') === 'dark' ? false : true;
    this.calThemeChng();
  }
  //Theme Switch button fuction to change light and dark theme
  onThemeSwitchChange() {
    this.isLightTheme = !this.isLightTheme;
    this.calThemeChng();
  }

  //Fuction to change light and dark theme for screens
  calThemeChng() {
    document.body.setAttribute(
      'data-theme',
      this.isLightTheme ? 'light' : 'dark'
    );
    localStorage.setItem('theme', this.isLightTheme ? 'light' : 'dark');
    window.dispatchEvent(new CustomEvent('theme-changed', {
      detail: { theme: this.isLightTheme ? 'light' : 'dark' }
    }));
  }
}
